import { config } from 'src/config/config';
import { UserDetails } from 'src/modules/user/models/user';
import { httpClient } from 'src/config/http';
import { ToastNotificationsService } from 'src/shared/services/ToastNotificationsService';

import { CategoryMeta, SelectedCategory } from '../models/ConnectToAnExpert';

interface SubmissionProps {
    userInfo: UserDetails;
    therapistRequested: boolean;
    psychiatristRequested?: boolean;
    anythingElse?: string;
    phoneNumber?: string;
    categories?: (SelectedCategory | CategoryMeta)[];
    tags?: string[];
    careRecUuid?: string;
}

export class ConnectToAnExpertService {
    constructor(private toastNotificationsService: ToastNotificationsService) {}

    public async submitForm(
        {
            userInfo,
            therapistRequested,
            psychiatristRequested,
            anythingElse,
            phoneNumber,
            categories,
            tags = [],
            careRecUuid,
        }: SubmissionProps,
        onSuccess?: () => void,
    ): Promise<void> {
        try {
            const submittedAt = new Date().toISOString();

            const requestData = {
                name: `${userInfo.firstName} ${userInfo.lastName}`,
                emailAddress: userInfo.email,
                careRecommendationUuid: careRecUuid,
                submittedAt,
                therapistRequested,
                psychiatristRequested,
                tags,
            };

            if (anythingElse) {
                requestData['anythingElse'] = anythingElse;
            }

            if (phoneNumber) {
                requestData['phoneNumber'] = phoneNumber;
            }

            if (categories) {
                // Backend expects `categories` field instead of `subcategories`
                requestData['categories'] = categories.map(category => ({
                    ...category,
                    categories: category.subcategories,
                }));
            }

            await httpClient.POST('connect-to-expert/connect_to_expert_submission/', requestData);

            if (onSuccess) {
                onSuccess();
            }
        } catch {
            this.toastNotificationsService.renderErrorToast(config.messages.genericError);
        }
    }
}
